if (!customElements.get('sticky-atc')) {

  class StickyATC extends HTMLElement {

    variantChangeUnsubscriber = undefined;
    observer = null;
    observedTarget = null;

    connectedCallback() {

      // ELEMENTS
      this.button = this.querySelector('[data-sticky-atc-btn]');
      this.colorSelector = this.querySelector('.product__color-selector');
      this.variantSelector = this.querySelector('.product__variant-selector');
      this.mobileButton = this.querySelector('.mobile-trigger button');

      document.documentElement.style.setProperty(
        '--footer-offset',
        `${this.offsetHeight}px`
      );

      this.observedTarget = document.querySelector('product-form');

      if (this.observedTarget) {
        this.observer = new IntersectionObserver(
          this.handleUpperIntersect.bind(this),
          {
            root: null,
            threshold: 0
          }
        );

        this.observer.observe(this.observedTarget);
      }

      // LISTENERS
      this.colorSelectorDrawerListener();
      this.variantSelectorListener();

      this.button?.addEventListener('click', this.onClickHandler.bind(this));
      this.mobileButton?.addEventListener('click', this.onClickHandlerMobile.bind(this));

      // VARIANT SYNC
      this.variantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        (event) => {
          this.variantSelector = this.querySelector('.product__variant-selector');

          if (!this.variantSelector) return;

          this.variantSelector
            .querySelectorAll('variant-selects select')
            .forEach((select, index) => {
              select.value = event.data.variant.options[index];
            });

          const idSelect = this.variantSelector.querySelector('select[name="id"]');
          if (idSelect) {
            idSelect.value = event.data.variant.id;
          }
        }
      );
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    handleUpperIntersect(entries) {
      const entry = entries[0];

      if (!entry) return;

      // MAIN ATC VISIBLE → HIDE STICKY
      if (entry.isIntersecting) {
        this.style.transform =
          'translateY(calc(100% + var(--layout-space-24)))';
      }
      // MAIN ATC NOT VISIBLE → SHOW STICKY
      else {
        this.style.transform = 'translateY(0)';
      }

      // Close drawers
      this.variantSelector?.classList.remove('active');
      this.colorSelector?.classList.remove('active');
    }

    colorSelectorDrawerListener() {
      const wrapper = this.colorSelector?.querySelector(
        '.product__color-selector--wrapper'
      );

      wrapper?.addEventListener('click', () => {
        this.colorSelector.classList.toggle('active');
        this.variantSelector?.classList.remove('active');
      });
    }

    variantSelectorListener() {
      const wrapper = this.variantSelector?.querySelector(
        '.product__variant-selector--wrapper'
      );

      wrapper?.addEventListener('click', () => {
        this.variantSelector.classList.toggle('active');
        this.colorSelector?.classList.remove('active');
      });
    }

    onClickHandler(event) {
      event.preventDefault();

      let mainAtc = document.querySelector(
        'product-form .product-form__submit.non-vieve-society[name="add"]'
      );

      const vieveSociety = document.querySelector('.vieve-society');
      const customer = swymCustomerId;

      if (vieveSociety) {
        const vieveMetafield = vieveSociety.getAttribute('data-metafield');
        const isQuickview = vieveSociety.getAttribute('data-quickview');

        if (
          customer == null &&
          vieveMetafield === 'true' &&
          isQuickview === 'false'
        ) {
          mainAtc = document.querySelector(
            'product-form .product-form__submit.vieve-society[name="add"]'
          );
        }
      }

      mainAtc?.click();
    }

    onClickHandlerMobile(event) {
      event.preventDefault();

      if (window.innerWidth < 750) {
        window.scroll({ top: 0, behavior: 'smooth' });
        let mainAtc = document.querySelector(
        'product-form .product-form__submit.non-vieve-society[name="add"]'
      );

      const vieveSociety = document.querySelector('.vieve-society');
      const customer = swymCustomerId;

      if (vieveSociety) {
        const vieveMetafield = vieveSociety.getAttribute('data-metafield');
        const isQuickview = vieveSociety.getAttribute('data-quickview');

        if (
          customer == null &&
          vieveMetafield === 'true' &&
          isQuickview === 'false'
        ) {
          mainAtc = document.querySelector(
            'product-form .product-form__submit.vieve-society[name="add"]'
          );
        }
      }

      mainAtc?.click();
      }
    }
  }

  customElements.define('sticky-atc', StickyATC);
}
